import app from "../_app";

const nav = document.querySelector('.js-nav');
const sideNav = document.querySelector('.js-side-nav');
const overlay =  document.querySelector('.side-nav__overlay');

if(nav) {
    const navItems = [...nav.querySelectorAll('.js-nav-item')];
    const sideNavItems = [...sideNav.querySelectorAll('.js-side-nav-item')];
    const backTriggers = [...nav.querySelectorAll('.js-nav-back')];
    const navTriggers = [...document.querySelectorAll('.js-nav-trigger')];

    const navItemClickHandler = (e) => {
        e.preventDefault();

        const items = [...document.querySelectorAll('.js-side-nav-sub-nav')];

        if(e.currentTarget.nextElementSibling.hasAttribute('data-open')) {
            e.currentTarget.nextElementSibling.removeAttribute('data-open');
        } else {
            items.map(item => item.removeAttribute('data-open'));
            e.currentTarget.nextElementSibling.setAttribute('data-open', '');
        }

        const mainItems = [...document.querySelectorAll('.js-nav-items')];
        mainItems.map((mainItem) => {
            mainItem.classList.add('away');
        });

    };

    const backClickHandler = (e) => {
        e.currentTarget.closest('.js-nav-sub-nav').removeAttribute('data-open');
        const mainItems = [...document.querySelectorAll('.js-nav-items')];
        mainItems.map((mainItem) => {
            mainItem.classList.remove('away');
        });
    };

    const triggerClickHandler = () => {
        if(app.viewport.isSmallerThan('lg')) {
            if(nav.hasAttribute('data-open')) {
                const openSubNavs = [...nav.querySelectorAll('.js-nav-sub-nav[data-open]')];

                nav.removeAttribute('data-open');
                overlay.classList.remove('active');

                openSubNavs.map(openSubNav => openSubNav.removeAttribute('data-open'));

                setTimeout(() => {
                    const mainItems = [...document.querySelectorAll('.js-nav-items')];
                    mainItems.map((mainItem) => {
                        mainItem.classList.remove('away');
                    });
                }, 300);

                app.unlockBody();
            } else {
                app.lockBody();
                nav.setAttribute('data-open', '');
                overlay.classList.add('active');
            }
        } else {
            if(sideNav.hasAttribute('data-open')) {
                const openSubNavs = [...sideNav.querySelectorAll('.js-side-nav-sub-nav[data-open]')];

                sideNav.removeAttribute('data-open');
                overlay.classList.remove('active');

                openSubNavs.map(openSubNav => openSubNav.removeAttribute('data-open'));

                app.unlockBody();
            } else {
                app.lockBody();
                sideNav.setAttribute('data-open', '');
                overlay.classList.add('active');
            }
        }
    };


    if(app.viewport.isSmallerThan('lg')) {
        navItems.map((navItem) => {
            navItem.firstElementChild.addEventListener('click', navItemClickHandler);
        });
    }else {
        sideNavItems.map((navItem) => {
            navItem.firstElementChild.addEventListener('click', navItemClickHandler);
        });
    }
    backTriggers.map(backTrigger => backTrigger.addEventListener('click', backClickHandler));
    navTriggers.map(navTrigger => navTrigger.addEventListener('click', triggerClickHandler));

    nav.removeAttribute('data-loading');

    document.querySelector('.nav__overlay').addEventListener('click', function(evt){
        if(this.classList.contains('active')){
            this.classList.remove('active');
            document.querySelector('.header').classList.remove('force-bg');
            document.querySelector('.js-searchbar').removeAttribute('data-open');
            app.unlockBody();
        }
    });
    overlay.addEventListener('click', function(evt){
        const openSubNavs = [...sideNav.querySelectorAll('.js-side-nav-sub-nav[data-open]')];

        sideNav.removeAttribute('data-open');
        overlay.classList.remove('active');
        openSubNavs.map(openSubNav => openSubNav.removeAttribute('data-open'));
        app.unlockBody();
    });
}
